export default "__VITE_ASSET__CUwwLk5a__"